import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootSaga from "./rootSaga";
import rootReducer from "./rootReducer";

const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "auth",
    "employee",
    "client",
    "vendor",
    "placement",
    "timesheet",
    "totalCount",
    "quickBooks",
    "reconciliation",
    "settings",
    "wfNotification",
    "benchsales",  // to persist candidate data in edit candidate page even after refresh 
    "internalDbES",
    "bdmJobs",
    "sourcing",
    "nonitMarketing",
    
  ], // Only persist auth state
  //whitelist: ["auth"], // Only persist auth state
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);
export default store;
